import React from "react";
import { Link } from "react-router-dom";
import { useAuthState, useAuthDispatch } from "../AuthProvider";

const BackToHomeLink = () => {
  const { isAuthenticated, clearSession } = useAuthState();

  React.useEffect(() => {
    try {
      clearSession();
    } catch (e) {
      console.log(e);
    }
  });
  return window.localStorage.getItem("LOGIN_TYPE") !== "MS-Email" &&
    isAuthenticated ? (
    <Link to="/">Back to Home</Link>
  ) : (
    <Link to="/">Sign In</Link>
  );
};

export default BackToHomeLink;
